var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('track-m',{staticClass:"display-mobile",attrs:{"speaker-config":_vm.speakerConfig,"speaker":_vm.speaker}}),_c('track-pc',{staticClass:"display-pc",attrs:{"speaker-config":_vm.speakerConfig,"speaker":_vm.speaker}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }